import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface PageImageLoader {
  getImageForPage(pageId: string): Observable<Blob>;
}

export const PAGE_IMAGE_LOADER_TOKEN = new InjectionToken<PageImageLoader>('PageImageLoader');
